module.exports = __webpack_public_path__ + "img/m_3.05863dfe.png";